module.exports = __webpack_public_path__ + "static/img/enterprise-icon.3132e4ef.png";